/**
 * CapitalEventsFeesStep Component
 * Step 3: Ad-hoc capital events and interest payment dates
 */

import React from 'react';
import {
  Box,
  Card,
  CardContent,
} from '@mui/material';
import AdhocCapitalSection from '../sections/AdhocCapitalSection';
import AdhocInterestPaymentSection from '../sections/AdhocInterestPaymentSection';

function CapitalEventsFeesStep() {
  return (
    <Box>
      {/* Scheduled Capital Movements (withdrawals/injections) */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <AdhocCapitalSection mode="capital" />
        </CardContent>
      </Card>

      {/* Adhoc Interest Accruals (carried from prior contract) */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <AdhocCapitalSection mode="accrual" />
        </CardContent>
      </Card>

      {/* Ad-hoc Interest Payment Dates */}
      <Card>
        <CardContent>
          <AdhocInterestPaymentSection />
        </CardContent>
      </Card>
    </Box>
  );
}

export default CapitalEventsFeesStep;
